import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { pipe } from 'rxjs';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';

@Component({
  selector: 'app-scenariohist',
  templateUrl: './scenariohist.component.html',
  styleUrls: ['./scenariohist.component.css']
})
export class ScenariohistComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap2', { static: true }) mapElement: any = {}
  scenarios: any = []
  scenarioid = 0
  phoneinfos: any = []
  phoneinfoid = 0
  overview: any = []
  records: any = []
  phoneinfo = ""
  gpslogs: any = []
  arrgpslogs: any = []
  scenario: any = {}
  scenariolayout: any = {}
  google_map: Google_map
  sortDir: any = []
  heightmin = 100
  heightmax = 0
  googlemapcircles: any = [];
  showAccuracy: any;
  pisc: any = []
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show()
    this.scenarios = await this.db.get("scenario", "getscenarios")
    this.scenarios.forEach((s: any) => {
      s.name = "(" + s.id + ") " + s.name
    })
    this.loader.hide()
  }
  async fetchData() {
    if (this.scenarioid > 0) {
      this.overview = await this.db.get("gpslog", "GetNRecByPhoneinfoForScenarioid", { scenarioid: this.scenarioid })
      this.overview.forEach((s: any) => {
        s.date = new Date(s.firstRecord.dateCreated);
        s.select = false
      })
      this.sortCol("date")
      this.sortCol("date")
    }
  }
  async selectByPhoneInfo(pi: any) {
    this.phoneinfo = pi.name
    this.gpslogs = await this.db.get("gpslog", "getgpslogsbyphoneinfo", { phoneinfo: this.phoneinfo });
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioid })

    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = JSON.parse(this.scenario.geometryJson)
      this.showMap()
    }
  }
  deleteSelected(pi: any) {

  }
  sortCol(fieldname: string) {
    this.sortGeneric(this.overview, fieldname, this.sortDir)
  }
  async plot() {
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioid })
    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = JSON.parse(this.scenario.geometryJson)
    }
    let pis: any = [];
    this.overview.forEach((o: any) => {
      if (o.select) pis.push(o.name)
    })

    let ordcolors = [
      "#1f77b4",
      "#ff7f0e",
      "#2ca02c",
      "#d62728",
      "#9467bd",
      "#8c564b",
      "#e377c2",
      "#7f7f7f",
      "#bcbd22",
      "#17becf"
    ]
    this.gpslogs = await this.db.post("gpslog", "GetLogsByScenarioAndPhoneInfos", pis, { scenarioid: this.scenarioid });
    this.pisc = [];
    pis.forEach((p: any, i: number) => {
      this.pisc.push({ name: p, color: ordcolors[i] })
    });
    this.gpslogs.forEach((l: any) => {
      let piscel = this.pisc.find((p:any) => p.name ==l.phoneInfo)
      l.color = piscel == null ? "#111111" : piscel.color
    })

    this.showMap()
  }
  showMap() {
    this.google_map = new Google_map()
    let latlng = this.scenariolayout.center
    let zoom = this.getZoom()
    this.google_map.init(this.mapElement.nativeElement, latlng, zoom)
    this.google_map.setMarker(latlng, "Center");

    this.scenariolayout.contours.forEach((p: any, i: number) => {
      let color = this.scenariolayout.contourdefinitions[i].color;
      this.google_map.addPolygon(p, color)
    })
    this.heightmin = 100
    this.heightmax = 0
    this.gpslogs.forEach((l: any) => {
      let latlng = { lat: l.latitude, lng: l.longitude }
      if (l.height > this.heightmax) { this.heightmax = l.height }
      if (l.height < this.heightmin) this.heightmin = l.height
    })

    this.googlemapcircles = []
    this.gpslogs.forEach((l: any, index: number) => {

      this.drawLog(index)
    })

  }
  getZoom() {
    let result = 14
    let min = 0
    let max = 0
    if (this.scenariolayout.contours.length > 0) {
      min = this.scenariolayout.contours[0][0].lat
      max = this.scenariolayout.contours[0][0].lat
      this.scenariolayout.contours.forEach((c: any) => {
        c.forEach((ll: any) => {
          if (ll.lat < min) min = ll.lat
          if (ll.lat > max) max = ll.lat
        })
      })
      let diff = max - min
      if (diff < 0.010) result = 15
      if (diff < 0.002) result = 17
    }
    return result
  }
  drawLog(index: number) {
    let l = this.gpslogs[index]
    let r = 255 * (l.height / this.heightmax)
    let b = 255 - 255 * (l.height / this.heightmax)
    let sColor = this.rgbToHex(r, 0, b)
    sColor = l.color
    if (this.showAccuracy) sColor = this.rgbToHex(0, 255, 0)
    let latlng = { lat: l.latitude, lng: l.longitude }
    let radius = this.showAccuracy ? l.accuracy : 2
    let transparency = this.showAccuracy ? 0.1 : 1.0
    let circle = this.google_map.addCircleNoTrans(latlng, radius, sColor, transparency);
    this.googlemapcircles.push(circle)
  }
  rgbToHex(r: number, g: number, b: number) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }
  componentToHex(c: number) {
    let i = Math.floor(c)
    let hex = i.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  select(pi: any) {
    pi.select = !pi.select
  }
}
